import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalQuery } from 'src/Libs/api'
import { fetchEmcStatus } from 'src/Libs/installations'
import { EmcStatusModel } from 'src/Libs/installations/models'

export const useEmcStatus = (
  serialnumber?: string
): {
  data?: EmcStatusModel
  isOnline: boolean
  isLoading: boolean
  isError: boolean
} => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['emc', 'status', serialnumber],
    queryFn: () => fetchEmcStatus(authFetch, serialnumber),
    enabled: !!serialnumber,
    staleTime: 0,
  })

  return {
    data: data ?? undefined,
    isOnline: data?.isOnline ?? false,
    isLoading,
    isError,
  }
}
